/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateContactRequest { 
    phone: string;
    firstname: string;
    lastname: string;
    note?: string | null;
    email?: string | null;
}

